import type { PlayerItemResponsePagedData } from '@on3/api';
import { Link } from '@on3/ui-lib/components/Link';
import { useSite } from '@on3/ui-lib/contexts/SiteProvider';

import styles from './LatestCommits.module.scss';
import { LatestCommitsPlayer } from './Player';

export const LatestCommits = ({ list }: PlayerItemResponsePagedData) => {
  const { currentSite, defaultYears } = useSite();
  const { footballRecruitingYear } = defaultYears;
  const recruitingYear = footballRecruitingYear;
  const isNational = currentSite?.isNational;
  const latestCommitsList = list?.slice(0, 5) ?? [];

  return (
    <section className={styles.block}>
      <header className={styles.header}>
        <h3>Latest Commitments</h3>
      </header>
      <ul className={styles.latestCommitsList}>
        {latestCommitsList.map((player) => (
          <li key={player.player?.key}>
            <LatestCommitsPlayer data={player} />
          </li>
        ))}
      </ul>
      <footer className={styles.footer}>
        {isNational ? (
          <>
            <Link
              className={styles.viewAll}
              href={`/recruiting/latest-commits/?sport=football`}
            >
              Football
            </Link>
            <Link
              className={styles.viewAll}
              href={`/recruiting/latest-commits/?sport=basketball`}
            >
              Basketball
            </Link>
          </>
        ) : (
          <Link
            className={styles.viewAll}
            href={`/college/${currentSite?.slug}/football/${recruitingYear}/industry-comparison-commits/`}
          >
            View all
          </Link>
        )}
      </footer>
    </section>
  );
};
